(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pc-announcement-bar"] && !Shopify.designMode) return;
  try {
    function initPartyCoolAnnouncements() {
  document.querySelectorAll('[data-pc-announcements]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = Array.from(root.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    let paused = root.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let hovering = false;
    let focused = false;
    const pauseButton = root.querySelector('[data-announcement-pause]');
    function schedule() {
      clearTimeout(timer);
      if (!root.isConnected || paused || hovering || focused || document.hidden) return;
      timer = setTimeout(() => { show(current + 1); }, Number(root.dataset.interval) || 6000);
    }
    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      schedule();
    }
    function syncPause() {
      pauseButton.setAttribute('aria-label', paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
      pauseButton.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    }
    root.querySelector('[data-announcement-prev]').addEventListener('click', () => show(current - 1));
    root.querySelector('[data-announcement-next]').addEventListener('click', () => show(current + 1));
    pauseButton.addEventListener('click', () => { paused = !paused; syncPause(); schedule(); });
    root.addEventListener('mouseenter', () => { hovering = true; clearTimeout(timer); });
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; clearTimeout(timer); });
    root.addEventListener('focusout', (event) => {
      focused = root.contains(event.relatedTarget);
      schedule();
    });
    document.addEventListener('visibilitychange', schedule);
    root.addEventListener('shopify:block:select', (event) => {
      const selected = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (selected < 0) return;
      paused = true;
      syncPause();
      show(selected);
    });
    syncPause();
    schedule();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPartyCoolAnnouncements);
} else {
  initPartyCoolAnnouncements();
}
document.addEventListener('shopify:section:load', initPartyCoolAnnouncements);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-branches"] && !Shopify.designMode) return;
  try {
    function initPartyCoolBranches() {
  document.querySelectorAll('.pc-branches').forEach((section) => {
    if (section.dataset.motionReady) return;
    section.dataset.motionReady = 'true';
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => section.classList.toggle('is-visible', entry.isIntersecting));
    }, { threshold: 0.15 });
    observer.observe(section);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPartyCoolBranches);
} else {
  initPartyCoolBranches();
}
document.addEventListener('shopify:section:load', initPartyCoolBranches);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-cart-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
  const notification = document.querySelector('[data-pc-cart-feedback]');
  if (!notification || !window.fetch || !window.FormData) return;
  const pending = new WeakSet();
  let cartRefresh = 0;
  const showMessage = (message, error = false) => {
    notification.classList.toggle('is-error', error);
    notification.classList.add('is-visible');
    notification.querySelector('[data-pc-cart-message]').textContent = message;
  };
  const refreshCount = async () => {
    const refresh = ++cartRefresh;
    try {
      const response = await fetch(notification.dataset.cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (refresh !== cartRefresh || !Number.isInteger(cart.item_count)) return;
      document.querySelectorAll('.pc-cart > span').forEach(count => { count.textContent = String(cart.item_count); });
    } catch {}
  };
  notification.querySelector('[data-pc-cart-dismiss]').addEventListener('click', () => {
    notification.classList.remove('is-visible');
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.pc-card-form, .pc-product-form')) return;
    if (event.submitter?.name === 'checkout') return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== location.origin || !/\/cart\/add\/?$/.test(action.pathname)) return;
    event.preventDefault();
    if (pending.has(form)) return;
    const data = new FormData(form);
    data.delete('return_to');
    action.pathname = action.pathname.replace(/\/$/, '') + '.js';
    pending.add(form);
    form.setAttribute('aria-busy', 'true');
    const controls = [...form.querySelectorAll('button[type="submit"]')].map(button => ({ button, disabled: button.disabled }));
    controls.forEach(({ button }) => { button.disabled = true; });
    try {
      const response = await fetch(action, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        showMessage(typeof result.description === 'string' ? result.description : notification.dataset.error, true);
      } else {
        showMessage(notification.dataset.success);
      }
    } catch {
      showMessage(notification.dataset.unknown, true);
    } finally {
      pending.delete(form);
      form.removeAttribute('aria-busy');
      controls.forEach(({ button, disabled }) => {
        const selected = form.querySelector('#pc-variant')?.selectedOptions[0];
        button.disabled = selected ? selected.dataset.available !== 'true' : disabled;
      });
      refreshCount();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-coupon-box"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-pc-apply-coupon]').forEach(button=>button.addEventListener('click',async()=>{const root=button.closest('.pc-coupon-box');const code=root.querySelector('input').value.trim();if(!code){root.querySelector('input').focus();return;}button.disabled=true;try{const form=button.closest('form');const response=await fetch(window.Shopify.routes.root+'cart/update.js',{method:'POST',body:new FormData(form)});if(!response.ok)throw new Error();window.location.assign(window.Shopify.routes.root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(window.Shopify.routes.root+'checkout'));}catch(e){button.disabled=false;root.querySelector('[data-pc-coupon-status]').textContent=root.querySelector('small').textContent;}}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-newest-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pc-newest-carousel')) {
  customElements.define('pc-newest-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pc-newest-track');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.controls = this.querySelector('.pc-newest-controls');
      this.previous = this.querySelector('.pc-newest-prev');
      this.next = this.querySelector('.pc-newest-next');
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 5;
        this.previous.disabled = position < 5;
        this.next.disabled = position >= max - 5;
        const step = this.track.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        const index = Math.min(3, Math.round(position / step));
        this.querySelectorAll('.pc-newest-dots i').forEach((dot, i) => dot.classList.toggle('is-current', i === index));
      };
      const move = direction => {
        const step = this.track.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * step * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', this.update, { passive: true, signal: this.controller.signal });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pc-card-purchase')) {
  customElements.define('pc-card-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.querySelector('select[name="id"]')?.addEventListener('change', event => {
        const option = event.target.selectedOptions[0];
        if (!option?.value) return;
        const display = this.querySelector('[data-price-display]');
        const onSale = Boolean(option.dataset.compare);
        display.classList.toggle('is-sale', onSale);
        display.querySelector('[data-price-from]').hidden = true;
        display.querySelector('[data-price-label]').hidden = !onSale;
        display.querySelector('[data-price-current]').textContent = option.dataset.price;
        const compare = display.querySelector('[data-price-old]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !onSale;
        const badge = this.closest('.pc-product-card').querySelector('[data-card-sale-badge]');
        if (badge) badge.hidden = !onSale;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
